import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


import Login from '@/views/auth/Login.vue'
import ForgetPassword from '@/views/auth/ForgetPassword.vue'

import Panel from '@/views/panel/Panel.vue'
import Home from '@/views/panel/Home.vue'
import AdminOperators from '@/views/panel/AdminOperators.vue'
import Users from '@/views/panel/Users.vue'
import ReferralCodes from '@/views/panel/ReferralCodes.vue'
import CompaniesList from '@/views/panel/CompaniesList.vue'

import DiscountCodeForm from '@/views/panel/discount/DiscountCodeForm.vue'
import DiscountCodesList from '@/views/panel/discount/DiscountCodesList.vue'

import Extensions from "@/views/panel/Extensions.vue"

import WalletUsers from "@/views/panel/WalletUsers.vue"
// import CrmHome from '@/views/crm/CrmHome.vue'
// import CrmLeads from '@/views/crm/CrmLeads.vue'
// import CrmLeadDetail from '@/views/crm/CrmLeadDetail.vue'
// import CrmFollowUps from '@/views/crm/CrmFollowUps.vue'
// import CrmDashboard from '@/views/crm/CrmDashboard.vue'
// import CrmOperators from '@/views/crm/CrmOperators.vue'
// import CrmContactsReport from '@/views/crm/CrmContactsReport.vue'
// import CrmOperatorContacts from '@/views/crm/CrmOperatorContacts.vue'
// import CrmDailyReport from '@/views/crm/CrmDailyReport.vue'

const routes = [{
  path: '/',
  name: 'Login',
  component: Login,
  props: true,
},
{
  path: '/forgetPassword',
  name: 'ForgetPassword',
  component: ForgetPassword
},
// {
//   path: '/crm',
//   name: 'CrmHome',
//   component: CrmHome,
// },
// {
//   path: '/crm/dashboard',
//   name: 'CrmDashboard',
//   component: CrmDashboard,
// },
// {
//   path: '/crm/leads',
//   name: 'CrmLeads',
//   component: CrmLeads,
// },
// {
//   path: '/crm/leads/:id',
//   name: 'CrmLeadDetail',
//   component: CrmLeadDetail,
//   props: true,
// },
// {
//   path: '/crm/follow-ups',
//   name: 'CrmFollowUps',
//   component: CrmFollowUps,
// },
// {
//   path: '/crm/operators',
//   name: 'CrmOperators',
//   component: CrmOperators,
// },
// {
//   path: '/crm/reports/contacts',
//   name: 'CrmContactsReport',
//   component: CrmContactsReport,
// },
// {
//   path: '/crm/contacts',
//   name: 'CrmOperatorContacts',
//   component: CrmOperatorContacts,
// },
// {
//   path: '/crm/reports/daily',
//   name: 'CrmDailyReport',
//   component: CrmDailyReport,
// },

{
  path: '/panel',
  name: 'Panel',
  component: Panel,
  children: [{
    path: 'home',
    name: 'Home',
    component: Home
  },
  {
    path: 'companies/list',
    name: 'CompaniesList',
    component: CompaniesList
  },
  {
    path: 'factors/list/:id?',
    name: 'FactorsList',
    component: FactorsList,
    props: true,
  },
  {
    path: 'AdminOperators',
    name: 'AdminOperators',
    component: AdminOperators
  },
  {
    path: 'users',
    name: 'Users',
    component: Users
  },
  {
    path: 'users/list',
    name: 'UsersList',
    component: UsersList
  },

  {
    path: 'referralCodes',
    name: 'ReferralCodes',
    component: ReferralCodes
  },
  {
    path: 'discountCode/form/:id?',
    props: true,
    name: 'DiscountCodeForm',
    component: DiscountCodeForm,
  },
  {
    path: 'discountCode/list',
    name: 'DiscountCodesList',
    component: DiscountCodesList
  },
  {
    path: 'usedDiscountCode/list',
    name: 'usedDiscountCodeList',
    component: DiscountCodeInFactorList
  },

  {
    path: 'extensions',
    name: 'Extensions',
    component: Extensions
  },
  {
    path: 'packages',
    name: 'Packages',
    component: Packages
  },
  {
    path: 'cloud-accounting',
    name: 'CloudAccounting',
    component: CloudAccounting
  },
  {
    path: 'withdrawal-management',
    name: 'WithdrawalManagement',
    component: WithdrawalManagement
  },
  {
    path: 'extension-adjustment',
    name: 'ExtensionAdjustment',
    component: ExtensionAdjustment
  },
  {
    path: 'admin-action-log',
    name: 'adminActionLog',
    component: AdminActionLogPage
  },
  {
    path: 'wallet-users',
    name: 'WalletUsers',
    component: WalletUsers
  },
  {
    path: 'monthly-sales-report',
    name: 'MonthlySalesReport',
    component: MonthlySalesReport
  },
  // { path: 'payment-gateways', name: 'PaymentGatewayManagement', component: PaymentGatewayManagement
  // },
  {
    path: 'moadian-submissions', name: 'MoadianSubmissions', component: MoadianSubmissions
  }
  ]
}

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


import navbar from "@/components/Navbar"
import {
  VExpansionPanel
} from 'vuetify/lib';
import FactorsList from "@/views/panel/FactorsList";
import UsersList from "@/views/panel/UsersList";
import DiscountCodeInFactorList from "@/views/panel/discount/DiscountCodeInFactorList";
import Packages from '@/views/panel/packages.vue'
import CloudAccounting from '@/views/panel/CloudAccounting.vue'
import WithdrawalManagement from '@/views/panel/WithdrawalManagement.vue'
import ExtensionAdjustment from '@/views/panel/ExtensionAdjustment.vue'
import AdminActionLogPage from '@/views/panel/AdminActionLogPage.vue'
import MonthlySalesReport from '@/views/panel/MonthlySalesReport.vue'
// import PaymentGatewayManagement from '@/views/panel/PaymentGatewayManagement.vue'
import MoadianSubmissions from '@/views/panel/MoadianSubmissions.vue'

let getTitle = (name, params, routes) => {
  let title = ''
  for (let route of routes) {
    if (route.to) {
      let is_same = route.to.name == name
      if (route.to.params && params) {
        Object.keys(params).forEach(key => {
          if (key == 'id') return;
          is_same &= route.to.params[key] == params[key]
        })
      }
      if (is_same) return route.title
    } else if (route.children) {
      title = getTitle(name, params, route.children)
      if (title) return title;
    }
  }
  return false
}

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    let title = getTitle(to.name, to.params, navbar.computed.allRoutes());
    if (!title) title = "ادمین - ابرمالی سبحان"
    document.title = title
  });
});

export default router
